

<div class="col-12 mt-2">
  <div class="col-12 flex border border-info rounded " #topDiv>
    <div class="col-6">
      <button pButton icon="fa fa-refresh" label="Refresh" class="buttonsRound noHover shadow w-3" 
      (click)="refreshTheReleaseList()"></button>
    </div>
    <div class="col-6 flex justify-content-end">
      <button pButton label="Release flagged projects" class="buttonsRound noHover float-right shadow w-3"
      [disabled]="!(setProjectNameForRelease && setProjectNameForRelease.length != 0)"
      (click)="releaseProject()"></button>
    </div>
   </div>

   <div class="col-12"   [style.height.px]="divHeight">
    <p-table #dt [value]="projectListVals" [columns]="scrollableCols" [loading]="loading" [style]="{'overflow':'visible', 'word-wrap': 'break-word'}"
      [scrollHeight]="scrollHeight" [scrollable]="true" #pp [paginator]="true" [rows]="15" (sortFunction)="customSort($event)" [customSort]="true" 
      sortField="projectName"  [sortOrder]="1">
      <ng-template pTemplate="caption">
        <div style="margin-left: 65%;">        
            <em class="fa fa-search" ></em>
            <input type="text" pInputText size="40" placeholder="Global Filter" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr >
          <th scope="col" class="text-center headerWidth" style="width: 15%;" pSortableColumn="projectName">Project
            <p-sortIcon field="projectName"></p-sortIcon>
            </th>
          <th scope="col" class="text-center headerWidth" style="width: 34%;" pSortableColumn="projectDescription">Details
            <p-sortIcon field="projectDescription"></p-sortIcon></th>
          <th scope="col" class="text-center headerWidth" style="width: 24%;" pSortableColumn="customer">Customer
            <p-sortIcon field="customer"></p-sortIcon></th>
          <th scope="col" class="text-center headerWidth"  pSortableColumn="noOflibs">No. of registered libs<br>[total (plannable | standby | canceled | planned)]
            <p-sortIcon field="noOflibs"></p-sortIcon></th>
          <th scope="col" class="text-center headerWidth" style="width: 8%;"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData" >
          <ng-container *ngFor="let col of columns">
            <td *ngIf="col.field=='projectName'" class="text-center rowtableWidth" style="width: 15%;">
              <a href="javascript:void(0);" (click)="getLibraryDialogBox(rowData,$event)"><u>{{rowData[col.field]}}</u></a>
            </td>
             <td *ngIf="col.field =='projectDescription'" class="text-center rowtableWidth" style="width: 34%;">
              <div class="scrollDiv" [innerHTML]="rowData.projectDescription">
              </div>
             </td>
             <td *ngIf="col.field =='customer'" class="text-center rowtableWidth" style="width: 24%;">
              {{rowData[col.field]}}
             </td>
            <td *ngIf="col.field =='noOflibs'" class="text-center rowtableWidth">
                {{getNooflibsFromMap(rowData.projectName)}}
            </td>
            <td *ngIf="col.field =='checkbox'" class="text-center rowtableWidth" style="width: 8%;">
              <input type="checkbox" [checked]="checkProjectNameInlist(rowData)" (change)="getDataForReleasingProject($event,rowData)"  />
            </td>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr >
          <td [attr.colspan]="5" class="text-center">
            No records found
          </td>
        </tr>
      </ng-template>
    </p-table>
   
    <p-dialog header="{{projectNameDialogDisplay}}" [(visible)]="projectPopup" [focusOnShow]="false" showEffect="fade" [modal]="true" [style]="{'width':'1200'}" [baseZIndex]="1000"  [dismissableMask]="true">
      <p-table #dt1  [value]="getdetailsOfLibraryOfProject" [columns]="scrollableColsforLibraryPopup" [scrollHeight]="scrollHeight" [scrollable]="true" #ppforlibs [paginator]="true" [rows]="15"
      sortField="libraryId"  [sortOrder]="1">
        <ng-template pTemplate="caption">
          <div style="margin-left: 65%;">        
              <em class="fa fa-search" ></em>
              <input type="text" pInputText size="40" placeholder="Global Filter" (input)="dt1.filterGlobal($event.target.value, 'contains')" style="width:auto">
          </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr >
            <th scope="col" class="text-center headerWidth" pSortableColumn="libraryId">Library Id
              <p-sortIcon  field="libraryId"></p-sortIcon>
              </th>
            <th scope="col" class="text-center headerWidth" pSortableColumn="sampleName">Sample Name
              <p-sortIcon field="sampleName"></p-sortIcon>
            </th>
            <th scope="col" class="text-center headerWidth" pSortableColumn="status">Status
              <p-sortIcon field="status"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr [pSelectableRow]="rowData" >
            <ng-container *ngFor="let col of columns">
              <td style="overflow:visible;word-break: break-word;" class="text-center">
                {{rowData[col.field]}}
              </td>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr >
            <td [attr.colspan]="3" class="text-center">
              No records found
            </td>
          </tr>
        </ng-template>
        </p-table>
  </p-dialog>
  <p-sidebar [(visible)]="releaseFlaggedpopup" position="right" [autoZIndex]="true"  [blockScroll]="false"
  [style]="{'width':'41em','top': '76px','padding-top': '32px','overflow': 'scroll','height':'91vh'}">
  Your are going to release available ready-to-be-planned libraries of projects <br /><br />
  <label class="font-weight-bold" style="padding-left: 85px;" *ngFor="let projectName of setProjectNameForRelease">
    {{projectName}}<br />
  </label><br />
  for run planning. <br />
  Please select the constraintType and an unique constraintId to complete the release <br />

  <div class="threshold">
    <label class="font-weight-bold">Constraint</label>
    <div>
      <label>constraint Type</label>
      <div>
        <p-dropdown [style]="{'width':'15em', 'maxWidth':'15em'}" [options]="constraintTypeOptions"
          [(ngModel)]="selectedConstraintType" placeholder="Select" (onChange)="checkValueForconstraintID($event.value)">
        </p-dropdown>
      </div>
    </div>
    <div><br />
      <label>constraint Id</label>
      <div *ngIf="showinputOnLoad">
        <input pInputText class="form-control" [disabled]="istextDisabled()" [(ngModel)]="enteredConstraintId">
      </div>
      <div *ngIf="!showinputOnLoad">
        <p-dropdown [style]="{'width':'15em', 'maxWidth':'15em'}" [options]="productIdsOptions" [(ngModel)]="enteredConstraintId"
        placeholder="Select">
      </p-dropdown>
      </div>
    </div>
  </div>
  <div class="col-4  float-right" style="padding-left: 42px">
    <button pButton label="Submit" class="buttonsRound noHover shadow" style="width: 150px;text-align: center;"  [disabled]="submitDisabledIf()"
      (click)="submitProjectDetails()"></button>
  </div>
  <div *ngIf = "erroMessageAfterUpdateFailed != ''" class="mt-5">
    <label class="m-0 text-danger" [innerHTML] = "erroMessageAfterUpdateFailed"></label>
  </div>
    </p-sidebar>
  </div>
  <p-confirmDialog [style]="{width: '20vw'}" [baseZIndex]="10000" [closable]="false"></p-confirmDialog>
</div>


<p-blockUI [blocked]="blocked">
  <div id="center" style="margin-top:260px; margin-left:800px;">
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>